// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1jUQu","layout":"JpKqz","table":"_8mN9","noResults":"_1K8r3","pageDropdown":"_24NeJ","heading":"_1Sf34","sortAscending":"_1z4l6","sortDescending":"_1hW_j","row":"_2PQEy","search":"NYGzU","settings":"Nx_I1","settingsToggle":"_3Z-p6","settingTrigger":"_3KU2L","settingContents":"JxuYa","high":"_3gX3v"};


//////////////////
// WEBPACK FOOTER
// ../src/components/Table/Table.css
// module id = 91
// module chunks = 0